module.exports = __webpack_public_path__ + "img/folder-shield.00d95fe0.svg";